import React, { FC, MutableRefObject, ReactElement, RefObject, useRef, useState } from 'react'
import { List, ListItem, ListItemIcon, ListItemText, Popper } from '@material-ui/core'
import { fromEvent, Subscription } from 'rxjs'
import { first } from 'rxjs/operators'
import Icon from '../../../../../React/Common/Components/Icon'
import { AvatarMenuItem } from '../../../../../React/Common/Types'
import { ArrayUtils } from '../../../../../NonReact/utils/ArrayUtils'

type Props = {
    item: AvatarMenuItem
}

export const UserMenuListItem: FC<Props> = ({ item }: Props): ReactElement => {
    const [isOpen, setIsOpen] = useState<boolean>(false)

    const ref: RefObject<HTMLDivElement> = useRef<HTMLDivElement>(null)

    const subscription: MutableRefObject<Nullable<Subscription>> = useRef<Nullable<Subscription>>()

    return (
        <ListItem
            ref={ref}
            button
            onClick={
                !ArrayUtils.isEmpty(item?.subMenu)
                    ? (): void => {
                          subscription.current?.unsubscribe()
                          setIsOpen((currentOpen: boolean): boolean => !currentOpen)

                          subscription.current = fromEvent(document, 'click')
                              .pipe(
                                  first(
                                      (event: Event): boolean =>
                                          !(event.target as HTMLElement).closest('.user-menu-sub-menu')
                                  )
                              )
                              .subscribe((): void => setIsOpen(false))
                      }
                    : item?.action
            }
            className='um-list-entry'
            key={item.label}
        >
            {item.icon ? (
                <ListItemIcon className='um-list-entry-icon'>
                    <Icon className={item.className} iconName={item.icon} />
                </ListItemIcon>
            ) : (
                <></>
            )}
            <ListItemText className='um-list-entry-text' primary={item.label} />
            {!ArrayUtils.isEmpty(item?.subMenu) ? (
                <Popper
                    className='user-menu-sub-menu user-menu-popper'
                    open={isOpen}
                    anchorEl={ref.current}
                    placement='left-start'
                >
                    <div className='user-menu'>
                        <div className='um-list-area'>
                            <List className='um-list'>
                                {item?.subMenu?.map(
                                    (subItem: AvatarMenuItem): ReactElement => (
                                        <ListItem
                                            key={subItem.label}
                                            onClick={subItem.action}
                                            className='um-list-entry'
                                        >
                                            <ListItemText className='um-list-entry-text'>{subItem.label}</ListItemText>
                                        </ListItem>
                                    )
                                )}
                            </List>
                        </div>
                    </div>
                </Popper>
            ) : (
                <></>
            )}
        </ListItem>
    )
}
